var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ReportNav", [
    _c(
      "div",
      { staticClass: "cpu-container" },
      [
        _c("div", { staticClass: "proportion-header-wrapper" }, [
          _c("div", { staticClass: "summary-tile-wrapper" }, [
            _c("div", { staticClass: "row" }, [
              _c("span", [_vm._v("总帧数")]),
              _c("span", [_vm._v(_vm._s(_vm.pageConfig.summary.totalFrame))]),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("span", [_vm._v("最高")]),
              _c("span", [
                _vm._v(_vm._s(_vm.pageConfig.summary.maxCost) + " ms"),
              ]),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("span", [_vm._v("最低")]),
              _c("span", [
                _vm._v(_vm._s(_vm.pageConfig.summary.minCost) + " ms"),
              ]),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("span", [_vm._v("中位数")]),
              _c("span", [
                _vm._v(_vm._s(_vm.pageConfig.summary.median) + " ms"),
              ]),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("span", [_vm._v("均值")]),
              _c("span", [
                _vm._v(_vm._s(_vm.pageConfig.summary.average) + " ms"),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "percentage-tile-wrapper" },
            _vm._l(_vm.summary, function (item, index) {
              return _c("div", { key: index, staticClass: "summary" }, [
                _c(
                  "div",
                  { staticClass: "summary-title" },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.pageConfig.summary[item].title)),
                    ]),
                    _vm.pageConfig.summary[item].help &&
                    _vm.pageConfig.summary[item].help > 0
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "right" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "rule-tip-content",
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _c("div", { staticClass: "rule-tip-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.help[
                                        _vm.pageConfig.summary[item].help
                                      ].title
                                    )
                                  ),
                                ]),
                                Boolean(_vm.pageConfig.summary[item].advice)
                                  ? _c(
                                      "div",
                                      { staticClass: "rule-tip-recommend" },
                                      [
                                        _vm._v("建议值"),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.pageConfig.summary[item]
                                                .advice.symbol === "lt"
                                                ? ">"
                                                : "<"
                                            ) +
                                              _vm._s(
                                                _vm.pageConfig.summary[item]
                                                  .advice.data[
                                                  _vm.reportDevice
                                                ][
                                                  _vm.pageConfig.summary[item]
                                                    .advice.data.length - 1
                                                ]
                                              ) +
                                              _vm._s(
                                                _vm.help[
                                                  _vm.pageConfig.summary[item]
                                                    .help
                                                ].unit
                                              )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "rule-tip-suggestion" },
                                  [_vm._v("优化建议")]
                                ),
                                _vm._l(
                                  _vm.help[
                                    _vm.pageConfig.summary[item].help
                                  ].optimize.split("\r\n"),
                                  function (tip, tipsIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          _vm.pageConfig.summary[item].help +
                                          "-" +
                                          tipsIndex,
                                        staticClass: "rule-tip-p",
                                      },
                                      [_vm._v(_vm._s(tip))]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c("i", { staticClass: "el-icon-question" }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "summary-value" }, [
                  _vm._v(
                    _vm._s(
                      (_vm.pageConfig.summary[item].value * 100).toFixed(0)
                    ) + "%"
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
        _c(
          "el-collapse",
          {
            staticClass: "tablist",
            model: {
              value: _vm.activeNames,
              callback: function ($$v) {
                _vm.activeNames = $$v
              },
              expression: "activeNames",
            },
          },
          _vm._l(_vm.pageConfig.chartInfo, function (item, index) {
            return _c(
              "el-collapse-item",
              { key: index, attrs: { name: index + "" } },
              [
                _c("template", { slot: "title" }, [
                  _c("div", { staticClass: "chart-title-wrapper" }, [
                    _c("i", { staticClass: "chart-title-tag" }),
                    _c(
                      "div",
                      { staticClass: "chart-title" },
                      [
                        _c("span", [_vm._v(_vm._s(item.title))]),
                        item.help && _vm.help[item.help]
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "right" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "rule-tip-content",
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "rule-tip-suggestion" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.help[item.help].title)
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.help[item.help].desc.split("\r\n"),
                                      function (tip, tipsIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.help + "-" + tipsIndex,
                                            staticClass: "rule-tip-p",
                                          },
                                          [_vm._v(_vm._s(tip))]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c("i", { staticClass: "el-icon-question" }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  [
                    _c("line-chart", {
                      staticClass: "line-chart",
                      attrs: { id: item.id, "chart-data": item.data },
                    }),
                  ],
                  1
                ),
              ],
              2
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }